"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const server_1 = require("@trpc/server");
const msw_1 = require("msw");
const getQueryInput = (req, transformer) => {
    const inputString = req.url.searchParams.get('input');
    if (inputString == null)
        return inputString;
    return transformer.input.deserialize(JSON.parse(inputString));
};
const getMutationInput = async (req, transformer) => {
    const body = await req.json();
    return transformer.output.deserialize(body);
};
const getRegexpAsString = (baseUrl) => {
    if (baseUrl instanceof RegExp === false)
        return baseUrl;
    let baseUrlAsString = `${baseUrl}`.replace('\\/', '');
    if (baseUrlAsString[0] === '/')
        baseUrlAsString = baseUrlAsString.substring(1);
    if (baseUrlAsString[baseUrlAsString.length - 1] === '/')
        baseUrlAsString = baseUrlAsString.substring(0, baseUrlAsString.length - 1);
    return baseUrlAsString;
};
const buildUrlFromPathParts = (pathParts) => new RegExp(pathParts.map(getRegexpAsString).join('[/.|.]') + '$');
// @ts-expect-error any
const createUntypedTRPCMsw = ({ baseUrl, basePath = 'trpc', transformer = server_1.defaultTransformer, } = {}, pathParts = []) => {
    return new Proxy({}, {
        get(_target, procedureKey) {
            if (procedureKey === 'query') {
                // @ts-expect-error any
                return handler => msw_1.rest.get(buildUrlFromPathParts(pathParts), (req, res, ctx) => {
                    const augmentedReq = Object.assign(Object.create(Object.getPrototypeOf(req)), req, {
                        getInput: () => getQueryInput(req, transformer),
                    });
                    return handler(augmentedReq, res, Object.assign(Object.assign({}, ctx), { 
                        // @ts-expect-error any
                        data: body => ctx.json({ result: { data: transformer.input.serialize(body) } }) }));
                });
            }
            if (procedureKey === 'mutation') {
                // @ts-expect-error any
                return handler => msw_1.rest.post(buildUrlFromPathParts(pathParts), (req, res, ctx) => {
                    const augmentedReq = Object.assign(Object.create(Object.getPrototypeOf(req)), req, {
                        getInput: () => getMutationInput(req, transformer),
                    });
                    return handler(augmentedReq, res, Object.assign(Object.assign({}, ctx), { 
                        // @ts-expect-error any
                        data: body => ctx.json({ result: { data: transformer.input.serialize(body) } }) }));
                });
            }
            const newPathParts = pathParts.length === 0 ? (baseUrl != null ? [baseUrl] : [`\/${basePath}`]) : pathParts;
            return createUntypedTRPCMsw({ transformer }, [...newPathParts, procedureKey]);
        },
    });
};
const createTRPCMsw = (config = {}) => {
    return createUntypedTRPCMsw(config);
};
exports.default = createTRPCMsw;
//# sourceMappingURL=createTRPCMsw.js.map